"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variants = exports.appearanceConfigs = void 0;
var _color = require("./color");
var variants = exports.variants = {
  small: {
    size: {
      arrow: 9
    },
    minWidth: 3.5,
    borderRadius: 0.3,
    padding: "0.2rem",
    minHeight: "2.8rem"
  },
  big: {
    size: {
      arrow: 15
    },
    padding: "2rem 1rem",
    minWidth: 20,
    borderRadius: 0.6
  }
};
var appearanceConfigs = exports.appearanceConfigs = {
  dark: {
    bgColor: "#212B36",
    color: _color.white,
    borderColor: "#212B36"
  },
  light: {
    bgColor: _color.white,
    color: "#6F7276",
    borderColor: "#E0E0E0"
  }
};